import { COURSE_TYPE, CourseLanguages, ICourse } from "@types";

export function getDurationString(duration: number) {
  const hours = Math.floor(duration / 3600);
  const mins = Math.floor((duration % 3600) / 60);
  let dur = hours > 0 ? `${hours}` : "";
  dur = dur + (hours > 0 ? " h" : "");
  dur = dur + (hours > 0 && mins > 0 ? " " : "");
  dur = dur + (mins > 0 ? `${mins}` : "");
  dur = dur + (mins > 0 ? " min" : "");
  return dur;
}
// eslint-disable-next-line no-unused-vars
export const languages: { [key in CourseLanguages]: string } = {
  fa: "فارسی",
  en: "انگلیسی",
  Persian: "فارسی",
  English: "انگلیسی",
};

export const isStringEmptyWithZw = (text: string) => {
  if (!text) return true;
  return !text
    .replace(/[\u200B-\u200D\uFEFF]/g, "") //&zwsp; &zwnj; &zwj; &zwnbsp;
    .replace(/\s+/g, "")
    .trim();
};

export const courseRoutes: string[] = [
  "/webinars/[slug]",
  "/blinds/[slug]",
  "/podcasts/[slug]",
  "/audiobooks/[slug]",
  "/exams/[slug]",
  "/courses/[slug]",
  "/services/[slug]",
  "/packages/[slug]",
  "/products/[slug]",
  "/texts/[slug]",
  "/videos/[slug]",
  "/books/[slug]",
];

export const productRoutes = courseRoutes.filter((p) => p !== "/videos/[slug]");

export const getUrlByCourseType = (
  type: COURSE_TYPE,
  webinar_status: string | undefined,
  slug: string
) => {
  const courseMainSlug: any = {
    [COURSE_TYPE.WEBINAR]: webinar_status !== "published" ? "/webinars/" : "",
    [COURSE_TYPE.BLIND]: "/blinds/",
    [COURSE_TYPE.PODCAST]: "/podcasts/",
    [COURSE_TYPE.AUDIOBOOK]: "/audiobooks/",
    [COURSE_TYPE.EXAM]: "/exams/",
    [COURSE_TYPE.PACK]: "/courses/",
    [COURSE_TYPE.COURSE]: "/courses/",
    [COURSE_TYPE.SERVICES]: "/services/",
    [COURSE_TYPE.PACKAGE]: "/packages/",
    [COURSE_TYPE.PHYSICAL]: "/products/",
    [COURSE_TYPE.TEXT]: "/texts/",
    [COURSE_TYPE.VIDEO]: "/videos/",
    [COURSE_TYPE.BOOK]: "/books/",
  };

  return (courseMainSlug[type] || "/courses/") + slug;
};

export function filterAndSortRecords(records: any[]) {
  const uniqueRecords = new Map();
  records.forEach((record) => {
    if (!uniqueRecords.has(record.created_at)) {
      uniqueRecords.set(record.created_at, record);
    }
  });
  return Array.from(uniqueRecords.values()).sort(
    (a, b) =>
      new Date(a.created_at).getTime() - new Date(b.created_at).getTime()
  );
}

export const getCourseCoverImage = (course: ICourse) => {
  const thumbnailImage =
    course.product?.png_cover && typeof course?.product?.png_cover === "string"
      ? course?.product?.png_cover
      : course?.product?.png_image;
  const safeThumbnailValue =
    thumbnailImage || course?.product?.png_image || course.product?.svg_image;
  return safeThumbnailValue;
};
